export default "__VITE_ASSET__BVynxikY__"